import React, { useState } from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box, Tab, Tabs } from '@mui/material';
import { useOutletContext } from 'react-router';
import { EmptyState, PageHeader, PagePaper, folderTabs } from 'dashboard/components/common';
import InvoicesTab from './InvoicesTab';
import TaxRulesTab from './TaxRulesTab';
import ReportsTab from './ReportsTab';

/**
 * Country-aware accounting hub for a brand: invoices, tax rules, and
 * reports. Each tab lives in its own file so dialogs stay focused.
 */
export default function Accounting() {
  const [selectedBrand] = useOutletContext();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PagePaper>
        <PageHeader
          title='Accounting'
          subtitle='Country-aware tax rules, invoices, and reporting. Brand overrides win over platform defaults.'
        />

        {!selectedBrand ? (
          <EmptyState>Select a brand to manage accounting.</EmptyState>
        ) : (
          <Box>
            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ ...folderTabs, mb: '16px' }}>
              <Tab label='Invoices' />
              <Tab label='Tax rules' />
              <Tab label='Reports' />
            </Tabs>
            {tab === 0 && <InvoicesTab brandId={selectedBrand} />}
            {tab === 1 && <TaxRulesTab brandId={selectedBrand} />}
            {tab === 2 && <ReportsTab brandId={selectedBrand} />}
          </Box>
        )}
      </PagePaper>
    </Box>
  );
}
